<div class="grid-1">
  @if (this.rating !== 5) {
    <app-card>
      <div class="text-center text-heading">We gebruiken jouw antwoorden om onze klantenservice-ervaring verder te verbeteren, voor jou én al onze andere klanten.</div>
      <div class="flex-justify">
        @if (this.imageSrc) {
          <img src="{{this.imageSrc}}" alt="" class="image">
        }
      </div>
      <div class="text-center">
        Je helpt ons enorm door jouw ervaring te delen via
        <a class="link-text-only" href="{{config.google_reviews_url}}" target="_blank">Google</a>
        of
        <a class="link-text-only" href="{{config.trustpilot_url}}" target="_blank">Trustpilot</a>.
      </div>
      <div class="icons">
        <div class="flex-justify">
          <a class="small" href="{{config.google_reviews_url}}" target="_blank"><img  src="/logo-google-review.png" alt="logo-google-review"></a>
          <a class="small" href="{{config.trustpilot_url}}" target="_blank"><img src="/logo-trustpilot.png" alt="logo-trustpilot"></a>
        </div>
      </div>
    </app-card>
  } @else {
    <app-card>
      <div class="text-center text-heading">Bedankt voor jouw positieve feedback!</div>
      <div class="stars">
        <app-stars [size]="'lg'" [disabled]="true" [numStarsSelected]="this.rating ? this.rating : 0"></app-stars>
      </div>
      <div class="text-center">
        Je helpt ons enorm door jouw ervaring te delen via
        <a class="link-text-only" href="{{config.google_reviews_url}}" target="_blank">Google</a>
        of
        <a class="link-text-only" href="{{config.trustpilot_url}}" target="_blank">Trustpilot</a>.
      </div>
      <div class="icons">
        <div class="flex-justify">
          <a class="big" href="{{config.google_reviews_url}}" target="_blank"><img src="/logo-google-review.png" alt="logo-google-review"></a>
          <a class="big" href="{{config.trustpilot_url}}" target="_blank"><img src="/logo-trustpilot.png" alt="logo-trustpilot"></a>
        </div>
      </div>
    </app-card>
  }
</div>
